module.exports = __webpack_public_path__ + "assets/views/intro/into_hub_button_bg.png";